module.exports = __webpack_public_path__ + "static/media/repair.94f0b221.svg";